"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAvatar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var UserAvatar_style_1 = __importDefault(require("./UserAvatar.style"));
/**
 * UserAvatar atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-useravatar--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/UserAvatar Source}
 */
var UserAvatar = function (_a) {
    var _b = _a.user, initials = _b.initials, profilePicture = _b.profilePicture, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.interactive, interactive = _d === void 0 ? false : _d, toggled = _a.toggled, className = _a.className, onClick = _a.onClick;
    var classes = (0, UserAvatar_style_1.default)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: className }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.root, size === 'large' && classes.large, size === 'medium' && classes.medium, size === 'compact' && classes.compact, size === 'tiny' && classes.tiny, interactive && classes.interactive, toggled && interactive && classes.toggled), onClick: onClick, style: __assign({}, (profilePicture && { backgroundImage: "url(data:image/jpeg;base64,".concat(profilePicture, ")") })) }, { children: profilePicture ? ((0, jsx_runtime_1.jsx)("object", __assign({ data: "data:image/jpeg;base64,".concat(profilePicture), type: 'image/jpeg', className: classes.photo }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.initials }, { children: initials })) }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.initials }, { children: initials }))) })) })));
};
exports.UserAvatar = UserAvatar;
